import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

import {ru} from './ru';
import {en} from './en';

i18n
    //.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'ru',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        load: 'all',
        resources: {
            ru: {
                translation: ru,
            },
            en: {
                translation: en,
            },
        }
    });

export default i18n;